
const state = {
  userCurrentPage: 1,
  groupCurrentPage: 1,
  categoryCurrentPage: 1,
  newsCurrentPage: [],
  logsListStatus: { input: { group: '0', category: '0'}, page: 1 },
  news_edit_item: {}
}

const getters = {
}

const mutations = {
  setUserCurrentPage(state, currentPage){
    state.userCurrentPage = currentPage
  },
  setGroupCurrentPage(state, currentPage){
    state.groupCurrentPage = currentPage
  },
  setCategoryCurrentPage(state, currentPage){
    state.categoryCurrentPage = currentPage
  },
  setNewsCurrentPage(state, currentPage){
    state.newsCurrentPage[currentPage.group] = currentPage.page
  },
  setLosgCurrentPage(state, status){
    state.logsListStatus = status
  },
  setNewsEditItem(state, item){
    state.news_edit_item = item
  }
}

const actions = {
  setUserCurrentPage(context,currentPage){
    context.commit('setUserCurrentPage', currentPage)
  },
  setGroupCurrentPage(context,currentPage){
    context.commit('setGroupCurrentPage', currentPage)
  },
  setCategoryCurrentPage(context,currentPage){
    context.commit('setCategoryCurrentPage', currentPage)
  },
  setNewsCurrentPage(context,currentPage){
    context.commit('setNewsCurrentPage', currentPage)
  },
  setLosgCurrentPage(context, status){
    context.commit('setLosgCurrentPage', status)
  },
  setNewsEditItem(context, item){
    context.commit('setNewsEditItem', item)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}